/* eslint-disable no-unused-vars */ export var HTTPResponseStatus = /*#__PURE__*/ function(HTTPResponseStatus) {
    HTTPResponseStatus[HTTPResponseStatus["Ok"] = 200] = "Ok";
    HTTPResponseStatus[HTTPResponseStatus["Created"] = 201] = "Created";
    HTTPResponseStatus[HTTPResponseStatus["BadRequest"] = 400] = "BadRequest";
    HTTPResponseStatus[HTTPResponseStatus["Unauthorized"] = 401] = "Unauthorized";
    HTTPResponseStatus[HTTPResponseStatus["Forbidden"] = 403] = "Forbidden";
    HTTPResponseStatus[HTTPResponseStatus["NotFound"] = 404] = "NotFound";
    HTTPResponseStatus[HTTPResponseStatus["Conflict"] = 409] = "Conflict";
    HTTPResponseStatus[HTTPResponseStatus["UnprocessableEntity"] = 422] = "UnprocessableEntity";
    HTTPResponseStatus[HTTPResponseStatus["FailedDependency"] = 424] = "FailedDependency";
    HTTPResponseStatus[HTTPResponseStatus["InternalServerError"] = 500] = "InternalServerError";
    HTTPResponseStatus[HTTPResponseStatus["BadGateway"] = 502] = "BadGateway";
    HTTPResponseStatus[HTTPResponseStatus["ServiceUnavailable"] = 503] = "ServiceUnavailable";
    return HTTPResponseStatus;
}({});
